export default __webpack_public_path__ + "static/media/laval12.09da041f.jpg";